import FooterSetup from '@/features/design-system/components/common/FooterSetup'
import { useUnits } from '@/hooks/useUnits'
import { DATA_PAGINATION } from '@/types'
import { Soil } from '@/types/soil'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'

interface Props {
  data?: DATA_PAGINATION<Soil>
}

const SoilTable: FC<Props> = ({ data }) => {
  const { convertLabelUnit, convertFromMetric } = useUnits()

  return (
    <Stack flexGrow="1" justifyContent="space-between">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  width: '29px',
                  position: 'sticky',
                  left: 0,
                }}
              >
                #
              </TableCell>
              <TableCell
                sx={{
                  width: '182px',
                  boxShadow: 'inset -1px 0px 0px #D7D7D7',
                  position: 'sticky',
                  left: 0,
                }}
              >
                Description
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Holding capabity (%)
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Wilting point (%)
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Intake Rate ({convertLabelUnit('mm/h')})
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Max Surface Accumulation ({convertLabelUnit('mm')})
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.data.map((row) => (
              <TableRow key={row.id}>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ position: 'sticky', left: 0 }}
                >
                  {row.id}
                </TableCell>
                <TableCell
                  sx={{
                    width: '182px',
                    boxShadow: 'inset -1px 0px 0px #D7D7D7',
                    position: 'sticky',
                    left: 0,
                  }}
                >
                  {row.description}
                </TableCell>
                <TableCell>{row.holdingCapacity}</TableCell>
                <TableCell>{row.wiltingPoint}</TableCell>
                <TableCell>
                  {convertFromMetric(row.intakeRate, 'mm/h')}
                </TableCell>
                <TableCell>
                  {convertFromMetric(row.maxSurfaceAccumulation, 'mm')}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack mt="20px">
        <FooterSetup
          title={`${data?.totalCount || 0} rows of data detected`}
          subtitle="Review the data before proceeding"
        />
      </Stack>
    </Stack>
  )
}

export default SoilTable
